import { MyPagesRoutes } from "../../types/routes";
import { EmployeeShiftApplicationState, ScheduleShift, ShiftTypeEnum } from "./schedule-shift";

interface IFilterSettings {
	showApplicationShifts?: boolean;
	showDeclinedShifts?: boolean;
	showReadNews?: boolean;
	disabledSystems?: string;
	showESigningDocuments?: boolean;
	showDocuments?: boolean;
	showUnreadMessages?: boolean;
	showCalendarMonth?: boolean;
}

export class FilterSettings {
	readonly showApplicationShifts: boolean;
	readonly showDeclinedShifts: boolean;
	readonly showReadNews: boolean;
	readonly disabledSystems: string[];
	readonly showESigningDocuments: boolean;
	readonly showDocuments: boolean;
	readonly showUnreadMessages: boolean;
	readonly showCalendarMonth: boolean;
	constructor(values: Partial<IFilterSettings>) {
		this.showApplicationShifts = values.showApplicationShifts ?? defaultFilterSettings.showApplicationShifts;
		this.showDeclinedShifts = values.showDeclinedShifts ?? defaultFilterSettings.showDeclinedShifts;
		this.showReadNews = values.showReadNews ?? defaultFilterSettings.showReadNews;
		this.disabledSystems =
			values.disabledSystems && values.disabledSystems.length > 0
				? values.disabledSystems.split(",")
				: defaultFilterSettings.disabledSystems;
		this.showESigningDocuments = values.showESigningDocuments ?? defaultFilterSettings.showESigningDocuments;
		this.showDocuments = values.showDocuments ?? defaultFilterSettings.showDocuments;
		this.showUnreadMessages = values.showUnreadMessages ?? defaultFilterSettings.showUnreadMessages;
		this.showCalendarMonth = values.showCalendarMonth ?? defaultFilterSettings.showCalendarMonth;
	}

	filter(shifts: ScheduleShift[]) {
		return shifts.filter(
			(s) =>
				(this.showApplicationShifts ||
					s.shiftType !== ShiftTypeEnum.Application ||
					s.isApplicationShiftAssigned() ||
					s.isForSaleAndMyShift()) &&
				(this.showDeclinedShifts || s.applicationState !== EmployeeShiftApplicationState.Declined) &&
				this.disabledSystems.every((system) => s.system !== system),
		);
	}

	get hasFilterActive() {
		return (
			this.showApplicationShifts !== defaultFilterSettings.showApplicationShifts ||
			this.showDeclinedShifts !== defaultFilterSettings.showDeclinedShifts ||
			this.disabledSystems !== defaultFilterSettings.disabledSystems ||
			this.showESigningDocuments !== defaultFilterSettings.showESigningDocuments ||
			this.showDocuments !== defaultFilterSettings.showDocuments ||
			this.showReadNews !== defaultFilterSettings.showReadNews ||
			this.showUnreadMessages !== defaultFilterSettings.showUnreadMessages ||
			this.showCalendarMonth !== defaultFilterSettings.showCalendarMonth
		);
	}

	hasActiveFilterForLocation(location: string) {
		let activeLocationFilter = false;
		switch (location.replace("/", "")) {
			case MyPagesRoutes.Documents:
				activeLocationFilter =
					this.showDocuments !== defaultFilterSettings.showDocuments ||
					this.showESigningDocuments !== defaultFilterSettings.showESigningDocuments;
				break;
			case MyPagesRoutes.Messages:
				activeLocationFilter = this.showUnreadMessages !== defaultFilterSettings.showUnreadMessages;
				break;
			case MyPagesRoutes.Schedule:
				activeLocationFilter =
					this.showApplicationShifts !== defaultFilterSettings.showApplicationShifts ||
					this.showDeclinedShifts !== defaultFilterSettings.showDeclinedShifts;
				break;
			case MyPagesRoutes.News:
				activeLocationFilter = this.showReadNews !== defaultFilterSettings.showReadNews;
				break;
			default:
		}
		return this.disabledSystems !== defaultFilterSettings.disabledSystems || activeLocationFilter;
	}
}

export const defaultFilterSettings = {
	showApplicationShifts: true,
	showDeclinedShifts: false,
	disabledSystems: [],
	showReadNews: true,
	showESigningDocuments: true,
	showDocuments: true,
	showUnreadMessages: false,
	showCalendarMonth: true,
};
